import React, { useState } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import swal from "sweetalert";
import IndiaBoatsTopBar from "../Components/IndiaBoatsTopBar";
import PremiumNavbar from "../Components/PremiumNavbar";
export default function Login() {
  const API_URL = process.env.REACT_APP_API_BASE_URL;
  const [form, setForm] = useState({ email: "", password: "" });
const [errors, setErrors] = useState({});
const [loading, setLoading] = useState(false);
const handleChange = (e) => {
  const { name, value } = e.target;

  setForm((prev) => ({
    ...prev,
    [name]: value,
  }));

  setErrors((prev) => ({
    ...prev,
    [name]: "",
  }));
};
const validate = () => {
  let newErrors = {};

  if (!form.email) {
    newErrors.email = "Email is required";
  } else if (!/\S+@\S+\.\S+/.test(form.email)) {
    newErrors.email = "Invalid email";
  }

  if (!form.password) {
    newErrors.password = "Password is required";
  }

  return newErrors;
};

  const handleSubmit = async (e) => {
  e.preventDefault();

  const validationErrors = validate();

  if (Object.keys(validationErrors).length > 0) {
    setErrors(validationErrors);
    return;
  }

  setLoading(true);

  try {
    const response = await fetch(
      `${API_URL}User/login`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          UserName: form.email,
          Password: form.password,
        }),
      }
    );

    const data = await response.json();

    if (response.ok && data?.status === 200) {
      // ✅ SUCCESS
      swal("Success!", "Login successful!", "success");

      // Optional: store user
      localStorage.setItem("user", JSON.stringify(data.data));

      // redirect
      window.location.href = "/";
    } else {
      // ❌ INVALID LOGIN
      swal("Error!", data.message || "Invalid credentials", "error");
    }
  } catch (error) {
    console.error(error);
    swal("Error!", "Something went wrong!", "error");
  } finally {
    setLoading(false);
  }
};

  return (
    <>
      {/* <Header /> */}
      <IndiaBoatsTopBar />
      <PremiumNavbar />
      <section className="user-login-section-container">
  <div className="login-card">
    <h2 className="login-title">Welcome Back</h2>
    <p className="login-subtitle">
      Sign in to manage your bookings and preferences.
    </p>
    <form className="login-form" onSubmit={handleSubmit}>

      <div className="input-group">
        <label htmlFor="login-email" className="input-label">
          Email Address
        </label>
        <input
  type="email"
  name="email"
  className="login-input"
  placeholder="youremail@example.com"
  value={form.email}
  onChange={handleChange}
/>
{errors.email && <p className="error">{errors.email}</p>}

      </div>
      <div className="input-group">
        <label htmlFor="login-password" className="input-label">
          Password
        </label>
       <input
  type="password"
  name="password"
  className="login-input"
  placeholder="••••••••"
  value={form.password}
  onChange={handleChange}
/>
{errors.password && <p className="error">{errors.password}</p>}
      </div>
      <div className="login-options-row">
        <div className="remember-me">
          <input
            type="checkbox"
            id="remember-me-checkbox"
            className="login-checkbox"
          />
        <br></br>
          <label htmlFor="remember-me-checkbox" className="checkbox-label">
            Remember my details
          </label>
        </div>
        {/* <a href="#" className="forgot-password-link">
          Forgot Password?
        </a> */}
      </div>
     <button type="submit" className="login-submit-btn" disabled={loading}>
  {loading ? "Logging in..." : "Log In"}
</button>

    </form>
    <div className="login-footer">
      <p>
        Don't have an account?{" "}
        <a href="/signup" className="signup-link">
          Sign Up
        </a>
      </p>
     
    </div>
  </div>
</section>

      <Footer />
    </>
  );
}
